import CanvasStep1 from "./CanvasStep1.vue";
import CanvasStep2 from "./CanvasStep2.vue";
import importApi from "@/api/requests/import";
import { actionType } from "@/views/dashboard/workspace-integration/actionType";
import { LMS_PROVIDERS } from "@/constants";
import isURL from "validator/es/lib/isURL";

const platformKey = LMS_PROVIDERS.canvas.key;

export default function canvasSteps(t) {
  return [
    {
      component: CanvasStep1,
      action: {
        label: t("common.continue"),
        actionType: actionType.next,
        type: "primary",
      },
    },
    {
      headerTitle: t("imports.connectToCanvas"),
      component: CanvasStep2,
      action: {
        label: t("imports.connectCanvas"),
        actionType: actionType.submit,
        disabled: (formData) => {
          return !(
            isURL(formData.canvasUrl ?? "") &&
            formData?.canvasToken?.trim().length > 0
          );
        },
        type: "primary",
        onSubmit: async (formData) => {
          const { canvasUrl, canvasToken } = formData;
          const { data } = await importApi[platformKey].createCredentials(
            canvasUrl,
            canvasToken
          );
          return data;
        },
      },
    },
  ];
}
